import "./index.css";
import { Composition, staticFile } from "remotion";
import * as CaptionedVideoTemplate from "@/templates/captioned-video";
import * as TravelTemplate01 from "@/templates/travel-template-01";

// Each <Composition> is an entry in the sidebar!

export const RemotionRoot: React.FC = () => {
  return (
    <>
      <Composition
        id={CaptionedVideoTemplate.ID}
        component={CaptionedVideoTemplate.TemplateVideo}
        calculateMetadata={CaptionedVideoTemplate.calculateCaptionedVideoMetadata}
        schema={CaptionedVideoTemplate.captionedVideoSchema}
        width={1080}
        height={1920}
        defaultProps={{
          src: staticFile("sample-video.mp4"),
        }}
      />
      <Composition
        id="TravelTemplate01"
        component={TravelTemplate01.TemplateVideo}
        calculateMetadata={TravelTemplate01.calculateCaptionedVideoMetadata}
        schema={TravelTemplate01.captionedVideoSchema}
        width={1080}
        height={1920}
        defaultProps={{
          src: staticFile("sample-video.mp4"),
        }}
      />
    </>
  );
};
